import { MENTION_KIND, MentionKind } from "@/constants";
import { FilterOption } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans, useLingui } from "@lingui/react/macro";
import { ChevronLeftIcon, CircleIcon } from "lucide-react";

export default function PageMentionKinds({
  onChange,
  value,
  onBack,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["mention_kind"];
  onBack?: () => void;
}) {
  const { t } = useLingui();

  // Helpers
  const mentionKindFilters: FilterOption<MentionKind>[] = [
    [MENTION_KIND.AUDIO, t`Endast träffar i tal`],
    [MENTION_KIND.TEXT, t`Endast träffar i text (inkluderar metadata)`],
  ];

  const isArray = Array.isArray(value);

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      <CommandGroup>
        {mentionKindFilters.map(([mentionKind, label]) => {
          const isChecked = isArray
            ? value.includes(mentionKind)
            : value === mentionKind;

          return (
            <CommandItem
              key={mentionKind}
              onSelect={() => {
                onChange({
                  mention_kind: mentionKind,
                });
              }}
            >
              <div className="aspect-square size-4 shrink-0 rounded-full border border-input text-primary shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:ring-destructive/40 relative flex items-center justify-center">
                {isChecked && (
                  <CircleIcon className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-primary" />
                )}
              </div>

              {label}
            </CommandItem>
          );
        })}
      </CommandGroup>
    </>
  );
}
